import axios from 'axios';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/league/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/league/';

class LeagueService {
  getAllLeaguesByClient(clientId) {
    return axios.get(API_URL  + "client/" + clientId);
  }

  getAllLeagues() {
    return axios.get(API_URL );
  }

  getLeaguesForGlobalPage() {
    return axios.get(`${API_URL}globals`);
  }

  getYearsByLeagueId(leagueId){
    return axios.get(`${API_URL}${leagueId}/years` );
  }

  getLeague(leagueId){
    return axios.get(`${API_URL}${leagueId}` );
  }

  getLeaguesBySeasons(seasonIds) {
    return axios.get(API_URL + "seasons/" + seasonIds);
  }

  getSoSInfo(leagueId,year){
    return axios.get(`${API_URL}${leagueId}/year/${year}/sos`);
  }

  postLeague(league){
    return axios.post(`${API_URL}`,league);
  }

  getPlayerInsightsByTemplate(seasonId, templateId = 1, isTotal = true, minsPlayed = null) {
    const param = minsPlayed != null ? `?minsPlayed=${minsPlayed}` : '';
    return axios.get(`${API_URL}player-insights/season/${seasonId}/template/${templateId}/total/${isTotal}${param}`);
  }

  getPlayerInsightsByTemplateGlobal(seasonIds, templateId = 1, isTotal = true, teamIds = null, leagueIds = null, gpiFrom = null, gpiTo = null) {
    const params = new URLSearchParams();
    
    if (seasonIds) {
      seasonIds.forEach(id => params.append('seasonIds', id));
    }
    if (teamIds) {
      teamIds.forEach(teamId => params.append('teamIds', teamId));
    }
    if (leagueIds) {
      leagueIds.forEach(leagueId => params.append('leagueIds', leagueId));
    }

    if (!gpiFrom) {
      gpiFrom = 2200;
    }
    if (!gpiTo) {
      gpiTo = 9999999;
    }
    params.append('gpiFrom', gpiFrom);
    params.append('gpiTo', gpiTo);

    return axios.get(API_URL + "player-insights/global/template/" + templateId + "/total/" + isTotal + "?" + params.toString());
  }

  getTeamInsights(seasonId){
    return axios.get(API_URL + "team-insights/season/" + seasonId);
  }

  getTeamInsightsByTemplate(seasonId, templateId = 386, isTotal = true, minsPlayed = null) {
    const param = minsPlayed != null ? `?minsPlayed=${minsPlayed}` : '';
    return axios.get(`${API_URL}team-insights/season/${seasonId}/template/${templateId}/total/${isTotal}${param}`);
  }

  getTeamInsightsByTemplateBatch(templateId = 386, isTotal = true, seasonIds, eloFrom = 1500, eloTo = 3000) {
    const params = new URLSearchParams();
    
    if (Array.isArray(seasonIds)) {
      seasonIds.forEach(id => {
        params.append('seasonIds', id);
      });
    }
    params.append("eloFrom", eloFrom);
    params.append("eloTo", eloTo);

    return axios.get(`${API_URL}team-insights/global/template/${templateId}/total/${isTotal}?${params.toString()}`);
  }
  getLeagueAveragesByTemplateBatch(leagueIds, years, templateId = 1, isTotal = true) {
    const params = new URLSearchParams();

    if (Array.isArray(leagueIds)) {
      leagueIds.forEach(id => {
        params.append('leagueIds', id);
      });
    }

    if (Array.isArray(years)) {
      years.forEach(year => {
        params.append('years', year);
      });
    }

    return axios.get(API_URL + "league-insights/global/template/" + templateId + "/total/" + isTotal + "?" + params.toString());
  }

  postLeagueFollow(userId, leagueId) {
    return axios.post(API_URL + 'follow',
      {
        userId: userId,
        leagueId: leagueId
      }
     );
  }

  getFollowedLeagues(userId, onlySelf) {
    return axios.get(API_URL + 'follow/' + userId, { params: { onlySelf } });
  }

  switchPinnedLeagueFav(leagueId, pinned){
    return axios.put(`${API_URL}${leagueId}/pinned/${pinned}`);
  }

  getLeagueEloHistory(leagueId, dateFrom = null, dateTo = null) {
    const params = {};
    if (dateFrom) params.dateFrom = dateFrom;
    if (dateTo) params.dateTo = dateTo;
    return axios.get(`${API_URL}${leagueId}/elo-history`, { params });
  }

  getMultipleLeaguesEloHistory(leagueIds, dateFrom = null, dateTo = null) {
    const params = new URLSearchParams();
    
    if (Array.isArray(leagueIds)) {
      leagueIds.forEach(id => {
        params.append('leagueIds', id);
      });
    }
    
    if (dateFrom) params.append('dateFrom', dateFrom);
    if (dateTo) params.append('dateTo', dateTo);
    
    return axios.get(`${API_URL}elo-history?${params.toString()}`);
  }
}

export default new LeagueService();